import { type ReactNode } from 'react';

import { cn } from '@apps/web/lib/utils';

export function ListPageHeader({
    title,
    description,
    actions,
    className,
    colorScheme = 'auto',
}: {
    readonly title: ReactNode;
    readonly description?: ReactNode;
    readonly actions?: ReactNode;
    readonly className?: string;
    readonly colorScheme?: 'auto' | 'light';
}) {
    return (
        <header
            data-slot="list-page-header"
            className={cn(
                'shrink-0 text-[#002429] antialiased',
                colorScheme === 'auto' && 'dark:text-foreground',
                className,
            )}
        >
            <div className="flex min-h-9 flex-wrap items-center justify-between gap-4">
                <h1
                    data-slot="list-page-title"
                    className="text-2xl leading-[1.2] font-bold tracking-tight"
                >
                    {title}
                </h1>
                {actions && (
                    <div className="ml-auto flex flex-wrap items-center justify-end gap-2">
                        {actions}
                    </div>
                )}
            </div>
            {description && (
                <div
                    className={cn(
                        'mt-1 text-sm',
                        colorScheme === 'light'
                            ? 'text-[#617578]'
                            : 'text-muted-foreground',
                    )}
                >
                    {description}
                </div>
            )}
        </header>
    );
}
